import { Select, Slider, Typography } from '@material-ui/core'
import Perforation from 'designer/geoHandlers/Material/perforation'
import React from 'react'
import styles from './perforation.module.scss'

const PerforationEditor = () => {
  const [radius, setRadius] = React.useState<number>(0.3)
  const [distance, setDistance] = React.useState<number>(1)
  return (
    <div className={styles.root}>
      <div className={styles.preview}>preview</div>
      <div className={styles.settings}>
        <div className={styles.section}>
          <Typography className={styles.typo}>Shape</Typography>
          <Select></Select>
        </div>
        <div className={styles.section}>
          <Typography className={styles.typo}>Diameter</Typography>
          <Slider
            step={0.1}
            marks
            min={0.3}
            max={1.2}
            value={radius * 2}
            valueLabelDisplay="on"
            onChangeCommitted={(e, v) => {
              const val: number = typeof v === 'number' ? v : 0.3
              setRadius(val / 2)
              Perforation.radius = val / 2
            }}
          />
        </div>
        <div className={styles.section}>
          <Typography className={styles.typo}>Distance</Typography>
          <Slider
            step={0.1}
            marks
            min={0.5}
            max={1.5}
            value={distance}
            valueLabelDisplay="on"
            onChangeCommitted={(e, v) => {
              const val: number = typeof v === 'number' ? v : 0.3
              setDistance(val)
              Perforation.distance = val
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default PerforationEditor
